/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-restricted-imports */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import ListLoader from "../../../../components/loading/listLoader";

import ProductDetailForm from "./Components/ProductDetailForm";

const EditProductModule = (props) => {
  const history = useHistory();

  const { dataDetailProduct, loadingDetailProduct } = useSelector(
    (state) => state.service
  );

  return (
    <>
      <div className="p-d-flex p-jc-center detail-pm">
        <div className="card card-custom col-8 mb-4">
          <div className="card-header border-0 py-5">
            <h3 className="card-title align-items-start flex-column">
              <button onClick={() => history.goBack()} className="button-back">
                <span className="card-label font-weight-bolder text-dark">
                  <span className="icon-back mr-2"></span>Edit Produk
                </span>
              </button>
            </h3>
          </div>
          {loadingDetailProduct ? (
            <ListLoader />
          ) : (
            <ProductDetailForm
              type={"editpage"}
              dataProduct={dataDetailProduct}
              productId={props.productId}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default EditProductModule;
